import type { formatMetaDataArgs } from './formatMetaData.typed';

const formatMetaData = (args: formatMetaDataArgs) => {
  const { metaData } = args;

  let formattedMetaData: (string | undefined)[] = [];

  metaData.forEach((item) => {
    if (item) {
      formattedMetaData.push(item);
    }
  });

  return formattedMetaData;
};

export { formatMetaData };
